import IconHeart from '../../../../images/illustrated/heart-72.svg';
import IconPin from '../../../../images/illustrated/pin-72.svg';
import IconWow from '../../../../images/illustrated/wow-72.svg';

export interface IHighlightImageProps {
  icon: string;
  top?: number;
  bottom?: number;
  left?: number;
  right?: number;
}

export interface IHighlightProps {
  score: string;
  children: React.ReactNode;
  icon: string;
  iconPosition: Omit<IHighlightImageProps, 'icon'>;
}

interface IHighlight {
  score: string;
  description: string;
  icon: string;
  iconPosition: Omit<IHighlightImageProps, 'icon'>;
}

export const HIGHLIGHTS: IHighlight[] = [
  {
    score: '10',
    description: 'highlightCountries',
    icon: IconPin,
    iconPosition: {
      left: -40,
    },
  },
  {
    score: '6500',
    description: 'highlightServedCities',
    icon: IconWow,
    iconPosition: {
      right: -15,
      bottom: -36,
    },
  },
  {
    score: '+100',
    description: 'highlightPartnerCompanies',
    icon: IconHeart,
    iconPosition: {
      top: -24,
      right: -35,
    },
  },
];
